// extracted by mini-css-extract-plugin
export default {"workMain":"MainWork_workMain__G0pgs","faq":"MainWork_faq__3GPzR","QA":"MainWork_QA__1ocGP","heading":"MainWork_heading__Ccxl-"};